/* eslint-disable @typescript-eslint/no-unused-expressions */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import {
  GV_EVENT_DATA_LIST,
  GV_UNIQUE_PARAM_LIST,
  GV_USER_PROPERTIES,
} from './enum';
import { getSDKConfig } from '../utils/config';

function getCurrentTime() {
  const dateTime = new Date().getTime();
  return dateTime.toString();
}

function getTimeZone() {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return timezone;
}

function generateUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
    /[xy]/g,
    function (converted) {
      const random = (Math.random() * 16) | 0,
        value = converted === 'x' ? random : (random & 0x3) | 0x8;
      return value.toString(16);
    }
  );
}

// global function reset value on page load
function openWindowScopeConfig() {
  window.spnGlobalConfig = {
    spnBeaconNetworkStatus: true,
    priorityBeaconExecutionStart: true,
    batchedBeaconExecutionStart: true,
    periodicBeaconExecutionStart: true,
    spnGodavariAppSessionId: '',
    spnGodavariGaAnalyticsConfig: null,
    spnGodavariEventsSessionId: null,
    maxRecordPerMinute: 0,
  };
}

// function is call on body load
function createAppSessionID() {
  const appSessionId = getCurrentTime();
  window.spnGlobalConfig.spnGodavariAppSessionId = appSessionId;
}

// current app session Id get any where
function getAppSessionId() {
  return window?.spnGlobalConfig?.spnGodavariAppSessionId;
}

function createDOMElement(dom) {
  const { innerHTML, attributes, ele, styles, event, innerText, parent } = dom;
  const element = document.createElement(ele);
  if (attributes) {
    Object.keys(attributes).forEach(function (key) {
      element.setAttribute(key, attributes[key]);
    });
  }
  if (styles) {
    Object.keys(styles).forEach(function (key) {
      element.style[key] = styles[key];
    });
  }
  if (innerHTML) {
    element.innerHTML = innerHTML;
  }
  if (innerText) {
    element.innerHTML = innerText;
  }
  if (event && !event.isDisabled) {
    element.addEventListener(event.type, event.listener, event.capturing);
  }
  parent && parent?.appendChild(element);
  return element;
}

// once in life time unless localstorage clear then create again
function getUserId() {
  let userId = localStorage.getItem('GV_USER_ID');
  if (!userId) {
    userId = generateUUID() + '-' + new Date().getTime();
    localStorage.setItem('GV_USER_ID', userId);
  }
  return userId;
}

// once every session on page load only
function getSessionId() {
  let sessionId = generateUUID();
  return sessionId;
}

function eventDataTransformer(rawEventData = {}) {
  const dataLayerObj = {};
  const context = {};
  const event_data = {};
  for (let [key, val] of Object.entries(rawEventData)) {
    if (typeof rawEventData[key] == 'object') {
      for (let [inkey, inVal] of Object.entries(rawEventData[key])) {
        if (inkey in GV_USER_PROPERTIES) {
          context[GV_USER_PROPERTIES[inkey]] = inVal;
        }
        if (inkey in GV_EVENT_DATA_LIST) {
          event_data[GV_EVENT_DATA_LIST[inkey]] = inVal;
        }
      }
    }
    if (key in GV_UNIQUE_PARAM_LIST) {
      dataLayerObj[GV_UNIQUE_PARAM_LIST[key]] = val;
    }
  }
  if (
    localStorage.getItem('NETWORK_LOG_MODE') == 'true' ||
    localStorage.getItem('AUTO_ENABLE_NETWORK_LOG_MODE') == 'true'
  ) {
    if (typeof rawEventData?.panel_event_id != 'undefined') {
      dataLayerObj[GV_UNIQUE_PARAM_LIST.panel_event_id] =
        rawEventData.panel_event_id;
    }
  } else {
    delete dataLayerObj[GV_UNIQUE_PARAM_LIST.panel_event_id];
  }
  dataLayerObj.context = context;
  dataLayerObj.event_data = event_data;
  return dataLayerObj;
}

function timeDiffMinutes(endTime, startTime) {
  let difference = endTime.getTime() - startTime.getTime(); // This will give difference in milliseconds
  let resultInMinutes = difference / 60000;
  return Number.parseFloat(parseFloat(resultInMinutes).toFixed(1));
}

function getSessionTimeOutTime() {
  const sdkConfig = getSDKConfig();
  let sessionTimeOut = 30;
  if (sdkConfig?.general?.app_session_timeout > 0) {
    const timeOut = sdkConfig?.general?.app_session_timeout / 1000;
    if (timeOut > 0) {
      sessionTimeOut = timeOut / 60;
      sessionTimeOut = parseInt(sessionTimeOut);
    }
  }
  return sessionTimeOut;
}

function checKBlackListEventType(eventData = {}) {
  const sdkConfig = getSDKConfig();
  const blackList = sdkConfig?.blacklist;

  if (
    blackList?.event_types?.length > 0 &&
    blackList?.event_types?.includes(eventData?.event_type)
  ) {
    return true;
  }
  if (
    blackList?.event_categories?.length > 0 &&
    blackList?.event_categories?.includes(eventData?.event_category)
  ) {
    return true;
  }
  if (
    blackList?.event_name?.length > 0 &&
    blackList?.event_name?.includes(eventData?.event_name)
  ) {
    return true;
  }
  return false;
}

//const hour = Math.floor((seconds % (3600 * 24)) / 3600)
//const minute = Math.floor((seconds % 3600) / 60)
//const second = Math.floor(seconds % 60)
function secondsToDays(seconds = 0) {
  seconds = Number(seconds);
  const d = Math.floor(seconds / (3600 * 24));
  const days = d > 0 ? d : 1;
  return parseInt(days);
}

function millisecondsToDays(ms) {
  const days = Math.floor(ms / (24 * 60 * 60 * 1000));
  return days;
}

function getNextDateTime(currentTime = 0, days = 0) {
  const today = new Date(currentTime); // get today's date
  const tomorrow = new Date(today);
  tomorrow.setDate(today.getDate() + days); // Add 1 to today's date and set it to tomorrow
  const time = tomorrow.getTime();
  return time;
}

export {
  getCurrentTime,
  getTimeZone,
  openWindowScopeConfig,
  createAppSessionID,
  getAppSessionId,
  createDOMElement,
  getUserId,
  getSessionId,
  eventDataTransformer,
  timeDiffMinutes,
  getSessionTimeOutTime,
  checKBlackListEventType,
  secondsToDays,
  millisecondsToDays,
  getNextDateTime,
};
